import { render, staticRenderFns } from "./we-service-org-view.vue?vue&type=template&id=b4d241e0&scoped=true&"
import script from "./we-service-org-view.vue?vue&type=script&lang=js&"
export * from "./we-service-org-view.vue?vue&type=script&lang=js&"
import style0 from "./we-service-org-view.vue?vue&type=style&index=0&id=b4d241e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d241e0",
  null
  
)

export default component.exports